import styled from 'styled-components';


export const CoreValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

export const CoreValueItem = styled.div`
  background: #ffffff;
  border: 1px solid ${(props) => props.theme.borderColor || '#e0e0e0'};
  border-radius: 8px;
  text-align: center;
  padding: 2rem;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  }

  svg {
    color: ${(props) => props.theme.primary};
    margin-bottom: 1rem;
  }

  h3 {
    margin-bottom: 0.5rem;
    font-size: 1.3rem;
    color: ${(props) => props.theme.secondary};
    font-weight: 600;
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
    color: ${(props) => props.theme.text};
  }
`;
